// extracted by mini-css-extract-plugin
export default {"actionsGroup":"companies_actionsGroup__MEPNe","actionsContainer":"companies_actionsContainer__FOWYW"};